export { default } from './StepMiniBars';
